import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(guardarPizarra),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchNotificarCambiosPizarra);

import { call, takeLatest, select } from 'redux-saga/effects'; // ibook-api

import { getPantalla } from '../../selectors';
import { PANTALLA_LIBRO_ID, PANTALLA_VENTANA_ID } from '../../constantes'; // ibook-api/pizarra

import { NOTIFICAR_CAMBIOS } from '../../pizarra/actions'; // sagas

import { guardarPizarraLibro } from './pizarra-libro';
import { guardarPizarraVentana } from './pizarra-ventana';

function guardarPizarra() {
  var pantalla;
  return _regeneratorRuntime.wrap(function guardarPizarra$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getPantalla);

        case 2:
          pantalla = _context.sent;
          _context.t0 = pantalla;
          _context.next = _context.t0 === PANTALLA_LIBRO_ID ? 6 : _context.t0 === PANTALLA_VENTANA_ID ? 9 : 12;
          break;

        case 6:
          _context.next = 8;
          return call(guardarPizarraLibro);

        case 8:
          return _context.abrupt('return');

        case 9:
          _context.next = 11;
          return call(guardarPizarraVentana);

        case 11:
          return _context.abrupt('return');

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function watchNotificarCambiosPizarra() {
  return _regeneratorRuntime.wrap(function watchNotificarCambiosPizarra$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(NOTIFICAR_CAMBIOS, guardarPizarra);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

export default watchNotificarCambiosPizarra;